import { n as ne, t as te } from '../OrAutocompleteV3-961163d0.js';
import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, renderSlot, resolveComponent, createElementVNode, createVNode, withModifiers, toRef, createBlock, withCtx, mergeProps, createCommentVNode } from 'vue';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import { OrIconButtonV3 as script$4 } from '../or-icon-button-v3/index.js';
import { OrOverlayV3 as script$5 } from '../or-overlay-v3/index.js';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-4e69972f.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

const ModalContent = [
// Overflow
'overflow-auto',
// Spacing
'px-md md:px-lg'];

var script$3 = defineComponent({
  name: 'OrModalContent',
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-modal-content', ...ModalContent]);
    return {
      root,
      rootStyles
    };
  }
});

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */);
}

script$3.render = render$3;
script$3.__file = "src/components/or-modal-v3/partials/or-modal-content/OrModalContent.vue";

const ModalFooter = [
// Spacing
'px-md md:px-lg'];

var script$2 = defineComponent({
  name: 'OrModalFooter',
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-modal-footer', ...ModalFooter]);
    return {
      root,
      rootStyles
    };
  }
});

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */);
}

script$2.render = render$2;
script$2.__file = "src/components/or-modal-v3/partials/or-modal-footer/OrModalFooter.vue";

const ModalHeader = [
// Layout
'layout-row',
// Spacing
'px-md md:px-lg pb-sm md:pb-none',
// Typography
'typography-headline-2'];

var script$1 = defineComponent({
  name: 'OrModalHeader',
  components: {
    OrIconButton: script$4
  },
  emits: ['close'],
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    const {
      isMobile
    } = ne();
    // Styles
    const rootStyles = computed(() => ['or-modal-header', ...ModalHeader]);
    return {
      root,
      rootStyles,
      isMobile
    };
  }
});

const _hoisted_1 = {
  class: /*#__PURE__*/normalizeClass(['grow'])
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconButton = resolveComponent("OrIconButton");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", _hoisted_1, [renderSlot(_ctx.$slots, "default")]), createVNode(_component_OrIconButton, {
    icon: 'close',
    size: _ctx.isMobile ? 'l' : 'xl',
    onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.$emit('close'), ["stop"]))
  }, null, 8 /* PROPS */, ["size"])], 2 /* CLASS */);
}

script$1.render = render$1;
script$1.__file = "src/components/or-modal-v3/partials/or-modal-header/OrModalHeader.vue";

var ModalSize;
(function (ModalSize) {
  ModalSize["L"] = "l";
  ModalSize["M"] = "m";
  ModalSize["S"] = "s";
})(ModalSize || (ModalSize = {}));

const Modal = [
// Layout
'layout-column',
// Box
'w-full', 'h-full md:h-auto md:max-h-[min(calc(100%-(2*theme(spacing.3xl))),772px)]',
// Spacing
'py-md md:py-lg', 'gap-md md:gap-lg',
// Shape
'md:rounded-md',
// Elevation
'shadow-modal', 'dark:shadow-modal-dark',
// Typography
'typography-body-2-regular',
// Theme
'theme-background-default', 'dark:theme-background-default-dark', 'theme-foreground-default', 'dark:theme-foreground-default-dark'];
const ModalSizes = {
  [ModalSize.L]: [
  // Box
  'md:w-[1050px]'],
  [ModalSize.M]: [
  // Box
  'md:w-[700px]'],
  [ModalSize.S]: [
  // Box
  'md:w-[480px]']
};

var script = defineComponent({
  name: 'OrModal',
  components: {
    OrModalContent: script$3,
    OrModalFooter: script$2,
    OrModalHeader: script$1,
    OrOverlay: script$5
  },
  inheritAttrs: false,
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: () => ModalSize.M
    },
    // TODO: Remove after migration to Vue 3
    additionalStyles: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:state', 'open', 'close'],
  expose: ['root', 'state', 'open', 'close'],
  setup(props, context) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-modal-v3', ...Modal, ...ModalSizes[props.size], ...props.additionalStyles]);
    // State
    const {
      state,
      open,
      close
    } = te(toRef(props, 'isOpen'), context.emit);
    return {
      root,
      rootStyles,
      state,
      open,
      close
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrModalHeader = resolveComponent("OrModalHeader");
  const _component_OrModalContent = resolveComponent("OrModalContent");
  const _component_OrModalFooter = resolveComponent("OrModalFooter");
  const _component_OrOverlay = resolveComponent("OrOverlay");
  return _ctx.state === 'open' ? (openBlock(), createBlock(_component_OrOverlay, {
    key: 0,
    fullscreen: true
  }, {
    default: withCtx(() => [createElementVNode("div", mergeProps(_ctx.$attrs, {
      ref: 'root',
      class: _ctx.rootStyles
    }), [createVNode(_component_OrModalHeader, {
      onClose: _cache[0] || (_cache[0] = $event => _ctx.close())
    }, {
      default: withCtx(() => [renderSlot(_ctx.$slots, "header")]),
      _: 3 /* FORWARDED */
    }), createVNode(_component_OrModalContent, {
      class: normalizeClass(['grow'])
    }, {
      default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
      _: 3 /* FORWARDED */
    }), _ctx.$slots.footer ? (openBlock(), createBlock(_component_OrModalFooter, {
      key: 0
    }, {
      default: withCtx(() => [renderSlot(_ctx.$slots, "footer")]),
      _: 3 /* FORWARDED */
    })) : createCommentVNode("v-if", true)], 16 /* FULL_PROPS */)]),
    _: 3 /* FORWARDED */
  })) : createCommentVNode("v-if", true);
}

script.render = render;
script.__file = "src/components/or-modal-v3/OrModal.vue";

export { ModalSize, script as OrModalV3 };
